import { lazy as _lazy } from "react"

export type IconName =
  | "accessible"
  | "add"
  | "addPerson"
  | "archive"
  | "arrowDown"
  | "arrowLeft"
  | "arrowRight"
  | "arrowTopRight"
  | "arrowUp"
  | "asterisk"
  | "badge"
  | "bars"
  | "batchAdd"
  | "bed"
  | "bell"
  | "bidirectional"
  | "briefCase"
  | "brush"
  | "business"
  | "calendar"
  | "camera"
  | "car"
  | "cards"
  | "check"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "cityHall"
  | "clock"
  | "close"
  | "collapseColumn"
  | "companiesAvigilon"
  | "companiesBallparc"
  | "companiesMPS"
  | "companiesT2"
  | "companiesVigilant"
  | "components"
  | "creditCard"
  | "crown"
  | "disco"
  | "doubleChevronDown"
  | "doubleChevronLeft"
  | "doubleChevronRight"
  | "doubleChevronUp"
  | "download"
  | "duplicate"
  | "edit"
  | "entry"
  | "errorFill"
  | "exit"
  | "expand"
  | "externalUsers"
  | "eye"
  | "file"
  | "filter"
  | "flagAalandIslands"
  | "flagAfghanistan"
  | "flagAlbania"
  | "flagAlgeria"
  | "flagAndorra"
  | "flagAngola"
  | "flagAntiguaBarbuda"
  | "flagArgentina"
  | "flagArmenia"
  | "flagAustralia"
  | "flagAustria"
  | "flagAzerbaijan"
  | "flagBahamas"
  | "flagBahrain"
  | "flagBangladesh"
  | "flagBarbados"
  | "flagBelarus"
  | "flagBelgium"
  | "flagBelize"
  | "flagBenin"
  | "flagBhutan"
  | "flagBolivia"
  | "flagBosniaHerzegovina"
  | "flagBotswana"
  | "flagBrazil"
  | "flagBritishVirginIslands"
  | "flagBrunei"
  | "flagBulgaria"
  | "flagBurkinaFaso"
  | "flagBurundi"
  | "flagCambodia"
  | "flagCameroon"
  | "flagCanada"
  | "flagCapeVerde"
  | "flagCaymanIslands"
  | "flagCentralAfricanRepublic"
  | "flagChad"
  | "flagChile"
  | "flagChina"
  | "flagColombia"
  | "flagComoros"
  | "flagCostaRica"
  | "flagCroatia"
  | "flagCuba"
  | "flagCyprus"
  | "flagCzechia"
  | "flagDemocraticRepublicCongo"
  | "flagDenmark"
  | "flagDjibouti"
  | "flagDominica"
  | "flagDominicanRepublic"
  | "flagEastTimor"
  | "flagEcuador"
  | "flagEgypt"
  | "flagElSalvador"
  | "flagEquatorialGuinea"
  | "flagEritrea"
  | "flagEstonia"
  | "flagEthiopia"
  | "flagFalklandIslands"
  | "flagFaroeIslands"
  | "flagFiji"
  | "flagFinland"
  | "flagFrance"
  | "flagFrenchGuiana"
  | "flagGabon"
  | "flagGambia"
  | "flagGeorgia"
  | "flagGermany"
  | "flagGhana"
  | "flagGibraltar"
  | "flagGreece"
  | "flagGrenada"
  | "flagGuadeloupe"
  | "flagGuatemala"
  | "flagGuernsey"
  | "flagGuinea"
  | "flagGuyana"
  | "flagHaiti"
  | "flagHonduras"
  | "flagHongKong"
  | "flagHungary"
  | "flagIceland"
  | "flagIndia"
  | "flagIndonesia"
  | "flagIran"
  | "flagIraq"
  | "flagIreland"
  | "flagIsleOfMan"
  | "flagIsrael"
  | "flagItaly"
  | "flagIvoryCoast"
  | "flagJamaica"
  | "flagJapan"
  | "flagJersey"
  | "flagJordan"
  | "flagKazakhstan"
  | "flagKenya"
  | "flagKiribati"
  | "flagKosovo"
  | "flagKuwait"
  | "flagKyrgyzstan"
  | "flagLaos"
  | "flagLatvia"
  | "flagLebanon"
  | "flagLesotho"
  | "flagLiberia"
  | "flagLibya"
  | "flagLiechtenstein"
  | "flagLithuania"
  | "flagLuxembourg"
  | "flagMadagascar"
  | "flagMalawi"
  | "flagMalaysia"
  | "flagMaldives"
  | "flagMali"
  | "flagMalta"
  | "flagMarshallIslands"
  | "flagMauritania"
  | "flagMauritius"
  | "flagMexico"
  | "flagMicronesia"
  | "flagMoldova"
  | "flagMonaco"
  | "flagMongolia"
  | "flagMontenegro"
  | "flagMorocco"
  | "flagMozanbique"
  | "flagMyanmar"
  | "flagNamibia"
  | "flagNauru"
  | "flagNepal"
  | "flagNetherlands"
  | "flagNewZealand"
  | "flagNicaragua"
  | "flagNiger"
  | "flagNigeria"
  | "flagNorthKorea"
  | "flagNorthMacedonia"
  | "flagNorway"
  | "flagOman"
  | "flagPakistan"
  | "flagPalau"
  | "flagPalestine"
  | "flagPanama"
  | "flagPapuaNewGuinea"
  | "flagParaguay"
  | "flagPeru"
  | "flagPhilippines"
  | "flagPoland"
  | "flagPortugal"
  | "flagPuertoRico"
  | "flagQuatar"
  | "flagRepublicCongo"
  | "flagRomania"
  | "flagRussia"
  | "flagRwanda"
  | "flagSaintKittsNevis"
  | "flagSaintLucia"
  | "flagSaintVincentGrenadines"
  | "flagSamoa"
  | "flagSanMarino"
  | "flagSaoTomePrincipe"
  | "flagSaudiArabia"
  | "flagSenegal"
  | "flagSerbia"
  | "flagSeychelles"
  | "flagSierraLeone"
  | "flagSingapore"
  | "flagSlovakia"
  | "flagSlovenia"
  | "flagSolomonIslands"
  | "flagSomalia"
  | "flagSouthAfrica"
  | "flagSouthGeorgiaSandwichIslands"
  | "flagSouthKorea"
  | "flagSouthSudan"
  | "flagSpain"
  | "flagSriLanka"
  | "flagSudan"
  | "flagSuriname"
  | "flagSweden"
  | "flagSwitzerland"
  | "flagSyria"
  | "flagTaiwan"
  | "flagTajikistan"
  | "flagTanzania"
  | "flagThailand"
  | "flagTogo"
  | "flagTonga"
  | "flagTrinidadTobago"
  | "flagTunisia"
  | "flagTurkey"
  | "flagTurkmenistan"
  | "flagUganda"
  | "flagUkraine"
  | "flagUnitedArabEmirates"
  | "flagUnitedKingdom"
  | "flagUnitedStates"
  | "flagUruguay"
  | "flagUzbekistan"
  | "flagVenezuela"
  | "flagVietnam"
  | "flagYemen"
  | "flagZambia"
  | "flagZimbabwe"
  | "flexPark"
  | "gear"
  | "grid"
  | "hamburger"
  | "heartbeat"
  | "hiddenEye"
  | "home"
  | "idCard"
  | "image"
  | "info"
  | "infoOutline"
  | "kebab"
  | "key"
  | "licensePlateReader"
  | "lightbulb"
  | "link"
  | "list"
  | "lock"
  | "logOut"
  | "lot"
  | "mail"
  | "market"
  | "meatballs"
  | "mobilePhone"
  | "moneySymbol"
  | "moon"
  | "motorcycle"
  | "no"
  | "palette"
  | "paperAirplane"
  | "parking"
  | "pass"
  | "passwordInput"
  | "paymentAmericanExpress"
  | "paymentApplePay"
  | "paymentDiscover"
  | "paymentGooglePay"
  | "paymentMastercard"
  | "paymentVisa"
  | "people"
  | "person"
  | "phone"
  | "pin"
  | "plug"
  | "promo"
  | "qrCode"
  | "question"
  | "range"
  | "receipt"
  | "refresh"
  | "remove"
  | "reorder"
  | "repeat"
  | "rocket"
  | "search"
  | "select"
  | "serviceBell"
  | "shoppingCart"
  | "share"
  | "speechBubble"
  | "subtract"
  | "sun"
  | "swap"
  | "tag"
  | "template"
  | "textEntry"
  | "ticket"
  | "translation"
  | "trash"
  | "unlink"
  | "upload"
  | "vendor"
  | "warning"
  | "zone"
  | "zoneGroup"

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function lazy(importFn: Function) {
  return _lazy(async () => {
    return await importFn()
  })
}
const icons: Record<
  IconName,
  React.LazyExoticComponent<React.ComponentType<React.SVGProps<SVGSVGElement>>>
> = {
  accessible: lazy(async () => import("@/assets/icons/accessible.svg")),
  add: lazy(async () => import("@/assets/icons/add.svg")),
  addPerson: lazy(async () => import("@/assets/icons/add-person.svg")),
  archive: lazy(async () => import("@/assets/icons/archive.svg")),
  arrowDown: lazy(async () => import("@/assets/icons/arrow-down.svg")),
  arrowLeft: lazy(async () => import("@/assets/icons/arrow-left.svg")),
  arrowRight: lazy(async () => import("@/assets/icons/arrow-right.svg")),
  arrowTopRight: lazy(async () => import("@/assets/icons/arrow-top-right.svg")),
  arrowUp: lazy(async () => import("@/assets/icons/arrow-up.svg")),
  asterisk: lazy(async () => import("@/assets/icons/asterisk.svg")),
  badge: lazy(async () => import("@/assets/icons/badge.svg")),
  bars: lazy(async () => import("@/assets/icons/bars.svg")),
  batchAdd: lazy(async () => import("@/assets/icons/batch-add.svg")),
  bed: lazy(async () => import("@/assets/icons/bed.svg")),
  bell: lazy(async () => import("@/assets/icons/bell.svg")),
  bidirectional: lazy(async () => import("@/assets/icons/bidirectional.svg")),
  briefCase: lazy(async () => import("@/assets/icons/brief-case.svg")),
  brush: lazy(async () => import("@/assets/icons/brush.svg")),
  business: lazy(async () => import("@/assets/icons/business.svg")),
  calendar: lazy(async () => import("@/assets/icons/calendar.svg")),
  camera: lazy(async () => import("@/assets/icons/camera.svg")),
  car: lazy(async () => import("@/assets/icons/car.svg")),
  cards: lazy(async () => import("@/assets/icons/cards.svg")),
  check: lazy(async () => import("@/assets/icons/check.svg")),
  chevronDown: lazy(async () => import("@/assets/icons/chevron-down.svg")),
  chevronLeft: lazy(async () => import("@/assets/icons/chevron-left.svg")),
  chevronRight: lazy(async () => import("@/assets/icons/chevron-right.svg")),
  chevronUp: lazy(async () => import("@/assets/icons/chevron-up.svg")),
  cityHall: lazy(async () => import("@/assets/icons/city-hall.svg")),
  clock: lazy(async () => import("@/assets/icons/clock.svg")),
  close: lazy(async () => import("@/assets/icons/close.svg")),
  collapseColumn: lazy(
    async () => import("@/assets/icons/collapse-column.svg")
  ),
  companiesAvigilon: lazy(
    async () => import("@/assets/icons/companies/avigilon.svg")
  ),
  companiesBallparc: lazy(
    async () => import("@/assets/icons/companies/ballparc.svg")
  ),
  companiesMPS: lazy(async () => import("@/assets/icons/companies/mps.svg")),
  companiesT2: lazy(async () => import("@/assets/icons/companies/t2.svg")),
  companiesVigilant: lazy(
    async () => import("@/assets/icons/companies/vigilant.svg")
  ),
  components: lazy(async () => import("@/assets/icons/components.svg")),
  creditCard: lazy(async () => import("@/assets/icons/credit-card.svg")),
  crown: lazy(async () => import("@/assets/icons/crown.svg")),
  disco: lazy(async () => import("@/assets/icons/disco.svg")),
  doubleChevronDown: lazy(
    async () => import("@/assets/icons/double-chevron-down.svg")
  ),
  doubleChevronLeft: lazy(
    async () => import("@/assets/icons/double-chevron-left.svg")
  ),
  doubleChevronRight: lazy(
    async () => import("@/assets/icons/double-chevron-right.svg")
  ),
  doubleChevronUp: lazy(
    async () => import("@/assets/icons/double-chevron-up.svg")
  ),
  download: lazy(async () => import("@/assets/icons/download.svg")),
  duplicate: lazy(async () => import("@/assets/icons/duplicate.svg")),
  edit: lazy(async () => import("@/assets/icons/edit.svg")),
  entry: lazy(async () => import("@/assets/icons/entry.svg")),
  errorFill: lazy(async () => import("@/assets/icons/error-fill.svg")),
  exit: lazy(async () => import("@/assets/icons/exit.svg")),
  expand: lazy(async () => import("@/assets/icons/expand.svg")),
  externalUsers: lazy(async () => import("@/assets/icons/external-users.svg")),
  eye: lazy(async () => import("@/assets/icons/eye.svg")),
  file: lazy(async () => import("@/assets/icons/file.svg")),
  filter: lazy(async () => import("@/assets/icons/filter.svg")),
  flagAalandIslands: lazy(
    async () => import("@/assets/icons/flags/aaland-islands.svg")
  ),
  flagAfghanistan: lazy(
    async () => import("@/assets/icons/flags/afghanistan.svg")
  ),
  flagAlbania: lazy(async () => import("@/assets/icons/flags/albania.svg")),
  flagAlgeria: lazy(async () => import("@/assets/icons/flags/algeria.svg")),
  flagAndorra: lazy(async () => import("@/assets/icons/flags/andorra.svg")),
  flagAngola: lazy(async () => import("@/assets/icons/flags/angola.svg")),
  flagAntiguaBarbuda: lazy(
    async () => import("@/assets/icons/flags/antigua-barbuda.svg")
  ),
  flagArgentina: lazy(async () => import("@/assets/icons/flags/argentina.svg")),
  flagArmenia: lazy(async () => import("@/assets/icons/flags/armenia.svg")),
  flagAustralia: lazy(async () => import("@/assets/icons/flags/australia.svg")),
  flagAustria: lazy(async () => import("@/assets/icons/flags/austria.svg")),
  flagAzerbaijan: lazy(
    async () => import("@/assets/icons/flags/azerbaijan.svg")
  ),
  flagBahamas: lazy(async () => import("@/assets/icons/flags/bahamas.svg")),
  flagBahrain: lazy(async () => import("@/assets/icons/flags/bahrain.svg")),
  flagBangladesh: lazy(
    async () => import("@/assets/icons/flags/bangladesh.svg")
  ),
  flagBarbados: lazy(async () => import("@/assets/icons/flags/barbados.svg")),
  flagBelarus: lazy(async () => import("@/assets/icons/flags/belarus.svg")),
  flagBelgium: lazy(async () => import("@/assets/icons/flags/belgium.svg")),
  flagBelize: lazy(async () => import("@/assets/icons/flags/belize.svg")),
  flagBenin: lazy(async () => import("@/assets/icons/flags/benin.svg")),
  flagBhutan: lazy(async () => import("@/assets/icons/flags/bhutan.svg")),
  flagBolivia: lazy(async () => import("@/assets/icons/flags/bolivia.svg")),
  flagBosniaHerzegovina: lazy(
    async () => import("@/assets/icons/flags/bosnia-herzegovina.svg")
  ),
  flagBotswana: lazy(async () => import("@/assets/icons/flags/botswana.svg")),
  flagBrazil: lazy(async () => import("@/assets/icons/flags/brazil.svg")),
  flagBritishVirginIslands: lazy(
    async () => import("@/assets/icons/flags/british-virgin-islands.svg")
  ),
  flagBrunei: lazy(async () => import("@/assets/icons/flags/brunei.svg")),
  flagBulgaria: lazy(async () => import("@/assets/icons/flags/bulgaria.svg")),
  flagBurkinaFaso: lazy(
    async () => import("@/assets/icons/flags/burkina-faso.svg")
  ),
  flagBurundi: lazy(async () => import("@/assets/icons/flags/burundi.svg")),
  flagCambodia: lazy(async () => import("@/assets/icons/flags/cambodia.svg")),
  flagCameroon: lazy(async () => import("@/assets/icons/flags/cameroon.svg")),
  flagCanada: lazy(async () => import("@/assets/icons/flags/canada.svg")),
  flagCapeVerde: lazy(
    async () => import("@/assets/icons/flags/cape-verde.svg")
  ),
  flagCaymanIslands: lazy(
    async () => import("@/assets/icons/flags/cayman-islands.svg")
  ),
  flagCentralAfricanRepublic: lazy(
    async () => import("@/assets/icons/flags/central-african-republic.svg")
  ),
  flagChad: lazy(async () => import("@/assets/icons/flags/chad.svg")),
  flagChile: lazy(async () => import("@/assets/icons/flags/chile.svg")),
  flagChina: lazy(async () => import("@/assets/icons/flags/china.svg")),
  flagColombia: lazy(async () => import("@/assets/icons/flags/colombia.svg")),
  flagComoros: lazy(async () => import("@/assets/icons/flags/comoros.svg")),
  flagCostaRica: lazy(
    async () => import("@/assets/icons/flags/costa-rica.svg")
  ),
  flagCroatia: lazy(async () => import("@/assets/icons/flags/croatia.svg")),
  flagCuba: lazy(async () => import("@/assets/icons/flags/cuba.svg")),
  flagCyprus: lazy(async () => import("@/assets/icons/flags/cyprus.svg")),
  flagCzechia: lazy(async () => import("@/assets/icons/flags/czechia.svg")),
  flagDemocraticRepublicCongo: lazy(
    async () => import("@/assets/icons/flags/democratic-republic-congo.svg")
  ),
  flagDenmark: lazy(async () => import("@/assets/icons/flags/denmark.svg")),
  flagDjibouti: lazy(async () => import("@/assets/icons/flags/djibouti.svg")),
  flagDominica: lazy(async () => import("@/assets/icons/flags/dominica.svg")),
  flagDominicanRepublic: lazy(
    async () => import("@/assets/icons/flags/dominican-republic.svg")
  ),
  flagEastTimor: lazy(
    async () => import("@/assets/icons/flags/east-timor.svg")
  ),
  flagEcuador: lazy(async () => import("@/assets/icons/flags/ecuador.svg")),
  flagEgypt: lazy(async () => import("@/assets/icons/flags/egypt.svg")),
  flagElSalvador: lazy(
    async () => import("@/assets/icons/flags/el-salvador.svg")
  ),
  flagEquatorialGuinea: lazy(
    async () => import("@/assets/icons/flags/equatorial-guinea.svg")
  ),
  flagEritrea: lazy(async () => import("@/assets/icons/flags/eritrea.svg")),
  flagEstonia: lazy(async () => import("@/assets/icons/flags/estonia.svg")),
  flagEthiopia: lazy(async () => import("@/assets/icons/flags/ethiopia.svg")),
  flagFalklandIslands: lazy(
    async () => import("@/assets/icons/flags/falkland-islands.svg")
  ),
  flagFaroeIslands: lazy(
    async () => import("@/assets/icons/flags/faroe-islands.svg")
  ),
  flagFiji: lazy(async () => import("@/assets/icons/flags/fiji.svg")),
  flagFinland: lazy(async () => import("@/assets/icons/flags/finland.svg")),
  flagFrance: lazy(async () => import("@/assets/icons/flags/france.svg")),
  flagFrenchGuiana: lazy(
    async () => import("@/assets/icons/flags/french-guiana.svg")
  ),
  flagGabon: lazy(async () => import("@/assets/icons/flags/gabon.svg")),
  flagGambia: lazy(async () => import("@/assets/icons/flags/gambia.svg")),
  flagGeorgia: lazy(async () => import("@/assets/icons/flags/georgia.svg")),
  flagGermany: lazy(async () => import("@/assets/icons/flags/germany.svg")),
  flagGhana: lazy(async () => import("@/assets/icons/flags/ghana.svg")),
  flagGibraltar: lazy(async () => import("@/assets/icons/flags/gibraltar.svg")),
  flagGreece: lazy(async () => import("@/assets/icons/flags/greece.svg")),
  flagGrenada: lazy(async () => import("@/assets/icons/flags/grenada.svg")),
  flagGuadeloupe: lazy(
    async () => import("@/assets/icons/flags/guadeloupe.svg")
  ),
  flagGuatemala: lazy(async () => import("@/assets/icons/flags/guatemala.svg")),
  flagGuernsey: lazy(async () => import("@/assets/icons/flags/guernsey.svg")),
  flagGuinea: lazy(async () => import("@/assets/icons/flags/guinea.svg")),
  flagGuyana: lazy(async () => import("@/assets/icons/flags/guyana.svg")),
  flagHaiti: lazy(async () => import("@/assets/icons/flags/haiti.svg")),
  flagHonduras: lazy(async () => import("@/assets/icons/flags/honduras.svg")),
  flagHongKong: lazy(async () => import("@/assets/icons/flags/hong-kong.svg")),
  flagHungary: lazy(async () => import("@/assets/icons/flags/hungary.svg")),
  flagIceland: lazy(async () => import("@/assets/icons/flags/iceland.svg")),
  flagIndia: lazy(async () => import("@/assets/icons/flags/india.svg")),
  flagIndonesia: lazy(async () => import("@/assets/icons/flags/indonesia.svg")),
  flagIran: lazy(async () => import("@/assets/icons/flags/iran.svg")),
  flagIraq: lazy(async () => import("@/assets/icons/flags/iraq.svg")),
  flagIreland: lazy(async () => import("@/assets/icons/flags/ireland.svg")),
  flagIsleOfMan: lazy(
    async () => import("@/assets/icons/flags/isle-of-man.svg")
  ),
  flagIsrael: lazy(async () => import("@/assets/icons/flags/israel.svg")),
  flagItaly: lazy(async () => import("@/assets/icons/flags/italy.svg")),
  flagIvoryCoast: lazy(
    async () => import("@/assets/icons/flags/ivory-coast.svg")
  ),
  flagJamaica: lazy(async () => import("@/assets/icons/flags/jamaica.svg")),
  flagJapan: lazy(async () => import("@/assets/icons/flags/japan.svg")),
  flagJersey: lazy(async () => import("@/assets/icons/flags/jersey.svg")),
  flagJordan: lazy(async () => import("@/assets/icons/flags/jordan.svg")),
  flagKazakhstan: lazy(
    async () => import("@/assets/icons/flags/kazakhstan.svg")
  ),
  flagKenya: lazy(async () => import("@/assets/icons/flags/kenya.svg")),
  flagKiribati: lazy(async () => import("@/assets/icons/flags/kiribati.svg")),
  flagKosovo: lazy(async () => import("@/assets/icons/flags/kosovo.svg")),
  flagKuwait: lazy(async () => import("@/assets/icons/flags/kuwait.svg")),
  flagKyrgyzstan: lazy(
    async () => import("@/assets/icons/flags/kyrgyzstan.svg")
  ),
  flagLaos: lazy(async () => import("@/assets/icons/flags/laos.svg")),
  flagLatvia: lazy(async () => import("@/assets/icons/flags/latvia.svg")),
  flagLebanon: lazy(async () => import("@/assets/icons/flags/lebanon.svg")),
  flagLesotho: lazy(async () => import("@/assets/icons/flags/lesotho.svg")),
  flagLiberia: lazy(async () => import("@/assets/icons/flags/liberia.svg")),
  flagLibya: lazy(async () => import("@/assets/icons/flags/libya.svg")),
  flagLiechtenstein: lazy(
    async () => import("@/assets/icons/flags/liechtenstein.svg")
  ),
  flagLithuania: lazy(async () => import("@/assets/icons/flags/lithuania.svg")),
  flagLuxembourg: lazy(
    async () => import("@/assets/icons/flags/luxembourg.svg")
  ),
  flagMadagascar: lazy(
    async () => import("@/assets/icons/flags/madagascar.svg")
  ),
  flagMalawi: lazy(async () => import("@/assets/icons/flags/malawi.svg")),
  flagMalaysia: lazy(async () => import("@/assets/icons/flags/malaysia.svg")),
  flagMaldives: lazy(async () => import("@/assets/icons/flags/maldives.svg")),
  flagMali: lazy(async () => import("@/assets/icons/flags/mali.svg")),
  flagMalta: lazy(async () => import("@/assets/icons/flags/malta.svg")),
  flagMarshallIslands: lazy(
    async () => import("@/assets/icons/flags/marshall-islands.svg")
  ),
  flagMauritania: lazy(
    async () => import("@/assets/icons/flags/mauritania.svg")
  ),
  flagMauritius: lazy(async () => import("@/assets/icons/flags/mauritius.svg")),
  flagMexico: lazy(async () => import("@/assets/icons/flags/mexico.svg")),
  flagMicronesia: lazy(
    async () => import("@/assets/icons/flags/micronesia.svg")
  ),
  flagMoldova: lazy(async () => import("@/assets/icons/flags/moldova.svg")),
  flagMonaco: lazy(async () => import("@/assets/icons/flags/monaco.svg")),
  flagMongolia: lazy(async () => import("@/assets/icons/flags/mongolia.svg")),
  flagMontenegro: lazy(
    async () => import("@/assets/icons/flags/montenegro.svg")
  ),
  flagMorocco: lazy(async () => import("@/assets/icons/flags/morocco.svg")),
  flagMozanbique: lazy(
    async () => import("@/assets/icons/flags/mozanbique.svg")
  ),
  flagMyanmar: lazy(async () => import("@/assets/icons/flags/myanmar.svg")),
  flagNamibia: lazy(async () => import("@/assets/icons/flags/namibia.svg")),
  flagNauru: lazy(async () => import("@/assets/icons/flags/nauru.svg")),
  flagNepal: lazy(async () => import("@/assets/icons/flags/nepal.svg")),
  flagNetherlands: lazy(
    async () => import("@/assets/icons/flags/netherlands.svg")
  ),
  flagNewZealand: lazy(
    async () => import("@/assets/icons/flags/new-zealand.svg")
  ),
  flagNicaragua: lazy(async () => import("@/assets/icons/flags/nicaragua.svg")),
  flagNiger: lazy(async () => import("@/assets/icons/flags/niger.svg")),
  flagNigeria: lazy(async () => import("@/assets/icons/flags/nigeria.svg")),
  flagNorthKorea: lazy(
    async () => import("@/assets/icons/flags/north-korea.svg")
  ),
  flagNorthMacedonia: lazy(
    async () => import("@/assets/icons/flags/north-macedonia.svg")
  ),
  flagNorway: lazy(async () => import("@/assets/icons/flags/norway.svg")),
  flagOman: lazy(async () => import("@/assets/icons/flags/oman.svg")),
  flagPakistan: lazy(async () => import("@/assets/icons/flags/pakistan.svg")),
  flagPalau: lazy(async () => import("@/assets/icons/flags/palau.svg")),
  flagPalestine: lazy(async () => import("@/assets/icons/flags/palestine.svg")),
  flagPanama: lazy(async () => import("@/assets/icons/flags/panama.svg")),
  flagPapuaNewGuinea: lazy(
    async () => import("@/assets/icons/flags/papua-new-guinea.svg")
  ),
  flagParaguay: lazy(async () => import("@/assets/icons/flags/paraguay.svg")),
  flagPeru: lazy(async () => import("@/assets/icons/flags/peru.svg")),
  flagPhilippines: lazy(
    async () => import("@/assets/icons/flags/philippines.svg")
  ),
  flagPoland: lazy(async () => import("@/assets/icons/flags/poland.svg")),
  flagPortugal: lazy(async () => import("@/assets/icons/flags/portugal.svg")),
  flagPuertoRico: lazy(
    async () => import("@/assets/icons/flags/puerto-rico.svg")
  ),
  flagQuatar: lazy(async () => import("@/assets/icons/flags/quatar.svg")),
  flagRepublicCongo: lazy(
    async () => import("@/assets/icons/flags/republic-congo.svg")
  ),
  flagRomania: lazy(async () => import("@/assets/icons/flags/romania.svg")),
  flagRussia: lazy(async () => import("@/assets/icons/flags/russia.svg")),
  flagRwanda: lazy(async () => import("@/assets/icons/flags/rwanda.svg")),
  flagSaintKittsNevis: lazy(
    async () => import("@/assets/icons/flags/saint-kitts-nevis.svg")
  ),
  flagSaintLucia: lazy(
    async () => import("@/assets/icons/flags/saint-lucia.svg")
  ),
  flagSaintVincentGrenadines: lazy(
    async () => import("@/assets/icons/flags/saint-vincent-grenadines.svg")
  ),
  flagSamoa: lazy(async () => import("@/assets/icons/flags/samoa.svg")),
  flagSanMarino: lazy(
    async () => import("@/assets/icons/flags/san-marino.svg")
  ),
  flagSaoTomePrincipe: lazy(
    async () => import("@/assets/icons/flags/sao-tome-principe.svg")
  ),
  flagSaudiArabia: lazy(
    async () => import("@/assets/icons/flags/saudi-arabia.svg")
  ),
  flagSenegal: lazy(async () => import("@/assets/icons/flags/senegal.svg")),
  flagSerbia: lazy(async () => import("@/assets/icons/flags/serbia.svg")),
  flagSeychelles: lazy(
    async () => import("@/assets/icons/flags/seychelles.svg")
  ),
  flagSierraLeone: lazy(
    async () => import("@/assets/icons/flags/sierra-leone.svg")
  ),
  flagSingapore: lazy(async () => import("@/assets/icons/flags/singapore.svg")),
  flagSlovakia: lazy(async () => import("@/assets/icons/flags/slovakia.svg")),
  flagSlovenia: lazy(async () => import("@/assets/icons/flags/slovenia.svg")),
  flagSolomonIslands: lazy(
    async () => import("@/assets/icons/flags/solomon-islands.svg")
  ),
  flagSomalia: lazy(async () => import("@/assets/icons/flags/somalia.svg")),
  flagSouthAfrica: lazy(
    async () => import("@/assets/icons/flags/south-africa.svg")
  ),
  flagSouthGeorgiaSandwichIslands: lazy(
    async () =>
      import("@/assets/icons/flags/south-georgia-sandwich-islands.svg")
  ),
  flagSouthKorea: lazy(
    async () => import("@/assets/icons/flags/south-korea.svg")
  ),
  flagSouthSudan: lazy(
    async () => import("@/assets/icons/flags/south-sudan.svg")
  ),
  flagSpain: lazy(async () => import("@/assets/icons/flags/spain.svg")),
  flagSriLanka: lazy(async () => import("@/assets/icons/flags/sri-lanka.svg")),
  flagSudan: lazy(async () => import("@/assets/icons/flags/sudan.svg")),
  flagSuriname: lazy(async () => import("@/assets/icons/flags/suriname.svg")),
  flagSweden: lazy(async () => import("@/assets/icons/flags/sweden.svg")),
  flagSwitzerland: lazy(
    async () => import("@/assets/icons/flags/switzerland.svg")
  ),
  flagSyria: lazy(async () => import("@/assets/icons/flags/syria.svg")),
  flagTaiwan: lazy(async () => import("@/assets/icons/flags/taiwan.svg")),
  flagTajikistan: lazy(
    async () => import("@/assets/icons/flags/tajikistan.svg")
  ),
  flagTanzania: lazy(async () => import("@/assets/icons/flags/tanzania.svg")),
  flagThailand: lazy(async () => import("@/assets/icons/flags/thailand.svg")),
  flagTogo: lazy(async () => import("@/assets/icons/flags/togo.svg")),
  flagTonga: lazy(async () => import("@/assets/icons/flags/tonga.svg")),
  flagTrinidadTobago: lazy(
    async () => import("@/assets/icons/flags/trinidad-tobago.svg")
  ),
  flagTunisia: lazy(async () => import("@/assets/icons/flags/tunisia.svg")),
  flagTurkey: lazy(async () => import("@/assets/icons/flags/turkey.svg")),
  flagTurkmenistan: lazy(
    async () => import("@/assets/icons/flags/turkmenistan.svg")
  ),
  flagUganda: lazy(async () => import("@/assets/icons/flags/uganda.svg")),
  flagUkraine: lazy(async () => import("@/assets/icons/flags/ukraine.svg")),
  flagUnitedArabEmirates: lazy(
    async () => import("@/assets/icons/flags/united-arab-emirates.svg")
  ),
  flagUnitedKingdom: lazy(
    async () => import("@/assets/icons/flags/united-kingdom.svg")
  ),
  flagUnitedStates: lazy(
    async () => import("@/assets/icons/flags/united-states.svg")
  ),
  flagUruguay: lazy(async () => import("@/assets/icons/flags/uruguay.svg")),
  flagUzbekistan: lazy(
    async () => import("@/assets/icons/flags/uzbekistan.svg")
  ),
  flagVenezuela: lazy(async () => import("@/assets/icons/flags/venezuela.svg")),
  flagVietnam: lazy(async () => import("@/assets/icons/flags/vietnam.svg")),
  flagYemen: lazy(async () => import("@/assets/icons/flags/yemen.svg")),
  flagZambia: lazy(async () => import("@/assets/icons/flags/zambia.svg")),
  flagZimbabwe: lazy(async () => import("@/assets/icons/flags/zimbabwe.svg")),
  flexPark: lazy(async () => import("@/assets/icons/flex-park.svg")),
  gear: lazy(async () => import("@/assets/icons/gear.svg")),
  grid: lazy(async () => import("@/assets/icons/grid.svg")),
  hamburger: lazy(async () => import("@/assets/icons/hamburger.svg")),
  heartbeat: lazy(async () => import("@/assets/icons/heartbeat.svg")),
  hiddenEye: lazy(async () => import("@/assets/icons/hidden-eye.svg")),
  home: lazy(async () => import("@/assets/icons/home.svg")),
  idCard: lazy(async () => import("@/assets/icons/id-card.svg")),
  image: lazy(async () => import("@/assets/icons/image.svg")),
  info: lazy(async () => import("@/assets/icons/info.svg")),
  infoOutline: lazy(async () => import("@/assets/icons/info-outline.svg")),
  kebab: lazy(async () => import("@/assets/icons/kebab.svg")),
  key: lazy(async () => import("@/assets/icons/key.svg")),
  licensePlateReader: lazy(
    async () => import("@/assets/icons/license-plate-reader.svg")
  ),
  lightbulb: lazy(async () => import("@/assets/icons/lightbulb.svg")),
  link: lazy(async () => import("@/assets/icons/link.svg")),
  list: lazy(async () => import("@/assets/icons/list.svg")),
  lock: lazy(async () => import("@/assets/icons/lock.svg")),
  logOut: lazy(async () => import("@/assets/icons/log-out.svg")),
  lot: lazy(async () => import("@/assets/icons/lot.svg")),
  mail: lazy(async () => import("@/assets/icons/mail.svg")),
  market: lazy(async () => import("@/assets/icons/market.svg")),
  meatballs: lazy(async () => import("@/assets/icons/meatballs.svg")),
  mobilePhone: lazy(async () => import("@/assets/icons/mobile-phone.svg")),
  moneySymbol: lazy(async () => import("@/assets/icons/money-symbol.svg")),
  moon: lazy(async () => import("@/assets/icons/moon.svg")),
  motorcycle: lazy(async () => import("@/assets/icons/motorcycle.svg")),
  no: lazy(async () => import("@/assets/icons/no.svg")),
  palette: lazy(async () => import("@/assets/icons/palette.svg")),
  paperAirplane: lazy(async () => import("@/assets/icons/paper-airplane.svg")),
  parking: lazy(async () => import("@/assets/icons/parking.svg")),
  pass: lazy(async () => import("@/assets/icons/pass.svg")),
  passwordInput: lazy(async () => import("@/assets/icons/password-input.svg")),
  paymentAmericanExpress: lazy(
    async () => import("@/assets/icons/payment-methods/american-express.svg")
  ),
  paymentApplePay: lazy(
    async () => import("@/assets/icons/payment-methods/apple-pay.svg")
  ),
  paymentDiscover: lazy(
    async () => import("@/assets/icons/payment-methods/discover.svg")
  ),
  paymentGooglePay: lazy(
    async () => import("@/assets/icons/payment-methods/google-pay.svg")
  ),
  paymentMastercard: lazy(
    async () => import("@/assets/icons/payment-methods/mastercard.svg")
  ),
  paymentVisa: lazy(
    async () => import("@/assets/icons/payment-methods/visa.svg")
  ),
  people: lazy(async () => import("@/assets/icons/people.svg")),
  person: lazy(async () => import("@/assets/icons/person.svg")),
  phone: lazy(async () => import("@/assets/icons/phone.svg")),
  pin: lazy(async () => import("@/assets/icons/pin.svg")),
  plug: lazy(async () => import("@/assets/icons/plug.svg")),
  promo: lazy(async () => import("@/assets/icons/promo.svg")),
  qrCode: lazy(async () => import("@/assets/icons/qr-code.svg")),
  question: lazy(async () => import("@/assets/icons/question.svg")),
  range: lazy(async () => import("@/assets/icons/range.svg")),
  receipt: lazy(async () => import("@/assets/icons/receipt.svg")),
  refresh: lazy(async () => import("@/assets/icons/refresh.svg")),
  remove: lazy(async () => import("@/assets/icons/remove.svg")),
  reorder: lazy(async () => import("@/assets/icons/reorder.svg")),
  repeat: lazy(async () => import("@/assets/icons/repeat.svg")),
  rocket: lazy(async () => import("@/assets/icons/rocket.svg")),
  search: lazy(async () => import("@/assets/icons/search.svg")),
  select: lazy(async () => import("@/assets/icons/select.svg")),
  serviceBell: lazy(async () => import("@/assets/icons/service-bell.svg")),
  shoppingCart: lazy(async () => import("@/assets/icons/shopping-cart.svg")),
  share: lazy(async () => import("@/assets/icons/share.svg")),
  speechBubble: lazy(async () => import("@/assets/icons/speech-bubble.svg")),
  subtract: lazy(async () => import("@/assets/icons/subtract.svg")),
  sun: lazy(async () => import("@/assets/icons/sun.svg")),
  swap: lazy(async () => import("@/assets/icons/swap.svg")),
  tag: lazy(async () => import("@/assets/icons/tag.svg")),
  template: lazy(async () => import("@/assets/icons/template.svg")),
  textEntry: lazy(async () => import("@/assets/icons/text-entry.svg")),
  ticket: lazy(async () => import("@/assets/icons/ticket.svg")),
  translation: lazy(async () => import("@/assets/icons/translation.svg")),
  trash: lazy(async () => import("@/assets/icons/trash.svg")),
  unlink: lazy(async () => import("@/assets/icons/unlink.svg")),
  upload: lazy(async () => import("@/assets/icons/upload.svg")),
  vendor: lazy(async () => import("@/assets/icons/vendor.svg")),
  warning: lazy(async () => import("@/assets/icons/warning.svg")),
  zone: lazy(async () => import("@/assets/icons/zone.svg")),
  zoneGroup: lazy(async () => import("@/assets/icons/zone-group.svg")),
}

export { icons }
